import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "Emily Davis",
    title: "Interior Architect",
    content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam quod ullam ea porro nisi, beatae, magni sed accusamus iusto fuga sunt perferendis itaque minima amet.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Michael Clark",
    title: "Lead Designer",
    content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam quod ullam ea porro nisi, beatae, magni sed accusamus iusto fuga sunt perferendis itaque minima amet.",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Sarah Evans",
    title: "Interior Designer",
    content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam quod ullam ea porro nisi, beatae, magni sed accusamus iusto fuga sunt perferendis itaque minima amet.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "John Smith",
    title: "Architect",
    content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam quod ullam ea porro nisi, beatae, magni sed accusamus iusto fuga sunt perferendis itaque minima amet.",
  },
];

export default testimonials;